import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    // 主页
    {
      path: '/',
      redirect: { name: 'home' }
    },
    {
      path: '/mxxq',
      name: 'mxxq',
      meta: {
        title: '优享免息'
      },
      component: () => import(/* webpackChunkName: "home" */ './views/IndexPage.vue')
      // component: Home
    },
    // 主页
    {
      path: '/home',
      name: 'home',
      meta: {
        title: '优享免息'
      },
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
      // component: Home
    },
    // guide
    // {
    //   path: '/guide',
    //   name: 'guide',
    //   meta: {
    //     title: '优享免息'
    //   },
    //   component: () => import(/* webpackChunkName: "guide" */ './views/Guide.vue')
    // },
    // 个人页面
    {
      path: '/me',
      name: 'me',
      meta: {
        title: '个人中心',
        keepAlive: false
      },
      // component: About
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "me" */ './views/Me.vue')
    },

    // 收藏夹
    {
      path: '/favorite',
      name: 'favorite',
      meta: {
        title: '收藏夹',
        keepAlive: false
      },
      component: () => import(/* webpackChunkName: "favorite" */ './views/Favorite.vue')
    },
    // 主题活动
    {
      path: '/activity',
      name: 'activity',
      meta: {
        title: '活动详情',
        keepAlive: false
      },
      component: () => import(/* webpackChunkName: "activity" */ './views/Activity.vue')
    },
    // 全部主题活动列表
    {
      path: '/activitylist',
      name: 'activitylist',
      meta: {
        title: '免息好物推荐'
      },
      component: () => import(/* webpackChunkName: "activitylist" */ './views/ActivityList.vue')
    },
    // 商品列表
    {
      path: '/goodslist',
      name: 'goodslist',
      meta: {
        title: '优享免息'
      },
      component: () => import(/* webpackChunkName: "goodslist" */ './views/GoodsList.vue')
    },
    // 评论列表
    {
      path: '/discusslist',
      name: 'discusslist',
      meta: {
        title: '全部评论',
        keepAlive: false
      },
      component: () => import(/* webpackChunkName: "discusslist" */ './views/DiscussList.vue')
    },
    // 发现页面discover
    {
      path: '/DiscoverPage',
      name: 'DiscoverPage',
      meta: {
        title: '发现' // title不能与底部菜单其他标题重名，否则无物理返回键的安卓机同标题菜单切换时会出现标题失踪现象
      },
      component: () => import(/* webpackChunkName: "discover" */ './views/DiscoverPage.vue')
    },
    // 评论页面
    {
      path: '/comment',
      name: 'comment',
      meta: {
        title: '评论'
      },
      component: () => import(/* webpackChunkName: "comment" */ './views/Comment.vue')
    },
    // 分类页面
    {
      path: '/category',
      name: 'category',
      meta: {
        title: '分类',
        keepAlive: false
      },
      component: () => import(/* webpackChunkName: "category" */ './views/Category.vue')
    },
    // 搜索页面
    {
      path: '/search',
      name: 'search',
      meta: {
        title: '搜索'
      },
      component: () => import(/* webpackChunkName: "search" */ './views/SearchPage.vue')
    }
  ]
});
